import "./send-to-kindle-afterSignIn.css";

class AfterSignIn {
    constructor() {
        // Init related properties (for now, there's nothing need to init for this page)
    }

    async preLoad() {
        // Prepare for loading page (for now, there's nothing need to prepare for this page)
        this.loadString();
        this.updateUserName();
        // After sign-in page need to be close automatically in 3 seconds
        setTimeout(function () {
            window.close();
        }, 3000);
    }

    // ################################ Initialization ################################
    /**
     * Load localization for all text attributes.
     */
    loadString() {
        $.each($("[s2k-string]"), function () {
            const $n = $(this);
            $n.text(chrome.i18n.getMessage($n.attr("s2k-string")));
        });
    }

    updateUserName() {
        // Get and update the username for the logged-in user.
        chrome.runtime.sendMessage({
            action: "update-username",
        }, function (res) {});
    }
}

window.onload = async () => {
    const app = new AfterSignIn();
    await app.preLoad();
};